import React from 'react';
import { Typography, Input, Select, Row, Col } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { OutlineButton, PrimaryButton } from '../Components/Buttons/Buttons';

const { Option } = Select;
const { Text } = Typography;

const CatalogueFilterBar = ({
    // Props per la ricerca (step 1 - colleghiamo solo la ricerca)
    searchTerm = '',
    onSearchChange,
    onApplyFilters,
    onClearFilters,

    // Props mock per gli altri filtri - li collegheremo dopo
    mainBrands = [],
    lines = [],
    gendersData = [],
    modelTypesData = [],
    sizesData = [],
    frameColorsData = [],
    frameShapesData = [],
    loadingBrands = false,
    loadingLines = false,
    loadingGenders = false,
    loadingModelTypes = false,
    loadingSizes = false,
    loadingFrameColors = false,
    loadingFrameShapes = false,
    filteredLines = [],
    selectedFilters = {
        brands: [],
        lines: [],
        genders: [],
        modelTypes: [],
        sizes: [],
        frameColors: [],
        frameShapes: [],
        age: []
    },
    userRole = 'User'
}) => {

    // Funzioni per la ricerca (step 1 - colleghiamo solo la ricerca)
    const handleSearchChange = (e) => {
        const value = e.target.value;
        if (onSearchChange) {
            onSearchChange(value);
        }
    };

    const handleApplyFilters = () => {
        if (onApplyFilters) {
            onApplyFilters();
        }
    };

    const handleClearFilters = () => {
        if (onClearFilters) {
            onClearFilters();
        }
    };

    // Funzioni mock per gli altri filtri - li collegheremo step by step
    const handleBrandChange = (values) => {
        console.log('Brand change:', values);
    };

    const handleLineChange = (values) => {
        console.log('Line change:', values);
    };

    const handleGenderChange = (values) => {
        console.log('Gender change:', values);
    };

    const handleModelTypeChange = (values) => {
        console.log('Model type change:', values);
    };

    const handleSizeChange = (values) => {
        console.log('Size change:', values);
    };

    const handleFrameColorChange = (values) => {
        console.log('Frame color change:', values);
    };

    const handleFrameShapeChange = (values) => {
        console.log('Frame shape change:', values);
    };

    const handleAgeChange = (values) => {
        console.log('Age change:', values);
    };

    // Controlla se ci sono filtri da applicare (termine di ricerca digitato o filtri selezionati)
    const hasFiltersToApply = () => {
        const hasSearchTerm = searchTerm && searchTerm.trim().length > 0;
        const hasFilters = (
            (selectedFilters.brands && selectedFilters.brands.length > 0) ||
            (selectedFilters.lines && selectedFilters.lines.length > 0) ||
            (selectedFilters.genders && selectedFilters.genders.length > 0) ||
            (selectedFilters.modelTypes && selectedFilters.modelTypes.length > 0) ||
            (selectedFilters.sizes && selectedFilters.sizes.length > 0) ||
            (selectedFilters.frameColors && selectedFilters.frameColors.length > 0) ||
            (selectedFilters.frameShapes && selectedFilters.frameShapes.length > 0) ||
            (selectedFilters.age && selectedFilters.age.length > 0)
        );
        return hasSearchTerm || hasFilters;
    };

    return (
        <div
            style={{
                width: '100%',
                borderRadius: '0.5rem',
                boxShadow: 'rgba(0, 0, 0, 0.05) 0px 4px 12px',
                cursor: 'default',
                marginBottom: '1.5rem',
                padding: '1rem',
                position: 'sticky',
                top: '0',
                zIndex: 1000,
                maxHeight: 'calc(100vh - 8rem)',
                overflowY: 'auto',
                maxWidth: '100%',
                boxSizing: 'border-box',
                backgroundColor: 'white',
                transition: 'top 0.2s ease'
            }}
        >
            {/* Title row - SENZA la sezione "Show news" come in ARSCatalog */}
            <Row justify="space-between" align="middle" gutter={[16, 16]} style={{ marginBottom: 'clamp(1rem, 2vw, 1.5rem)' }}>
                <Col>
                    <Typography.Title level={4} style={{ margin: 0 }}>Filters</Typography.Title>
                </Col>
            </Row>

            {/* Search input row */}
            <Row gutter={[0, 16]}>
                <Col span={24}>
                    <Text style={{ marginBottom: '8px', display: 'block' }}>Search product or variant</Text>
                    <Input
                        placeholder="Search by model name, variant name, SKU, EAN or UPC code..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        prefix={<SearchOutlined style={{ color: '#aaa' }} />}
                        allowClear
                        style={{
                            width: "100%",
                            borderRadius: "4px",
                            fontSize: "14px",
                            height: "32px",
                        }}
                    />
                </Col>
            </Row>

            {/* Filter content */}
            <div style={{
                marginTop: 'clamp(0.5rem, 1.5vw, 1rem)',
                animation: 'filterAnimation 0.3s ease-in-out',
            }}>
                <style>
                    {`
                    @keyframes filterAnimation {
                        0% { opacity: 0; transform: translateY(clamp(-0.625rem, -2vw, -0.9375rem)); }
                        100% { opacity: 1; transform: translateY(0); }
                    }
                    `}
                </style>
                {/* <Row gutter={[0, 16]}> */}
                {/* Brands section */}
                {/* <Col span={24}>
                        <div>
                            <Text>Select Brand</Text>
                            <Select
                                mode="multiple"
                                placeholder={loadingBrands ? "Loading brands..." : "Select brand"}
                                value={selectedFilters.brands || []}
                                onChange={handleBrandChange}
                                style={{ width: '100%', marginTop: '8px' }}
                                loading={loadingBrands}
                                disabled={loadingBrands || !mainBrands || mainBrands.length === 0}
                                allowClear
                                maxTagCount={2}
                                maxTagPlaceholder={(omitted) => `+ ${omitted.length} brands`}
                                showSearch
                                filterOption={(input, option) =>
                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                }
                            >
                                {mainBrands && mainBrands.map(brand => (
                                    <Option key={brand.value} value={brand.value}>
                                        {brand.label}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </Col> */}

                {/* Lines section */}
                {/* <Col span={24}>
                        <div>
                            <Text>Select Line</Text>
                            <Select
                                mode="multiple"
                                placeholder={loadingLines ? "Loading lines..." : "Select line"}
                                value={selectedFilters.lines || []}
                                onChange={handleLineChange}
                                style={{ width: '100%', marginTop: '8px' }}
                                loading={loadingLines}
                                allowClear
                                maxTagCount={2}
                                maxTagPlaceholder={(omitted) => `+ ${omitted.length} lines`}
                                disabled={loadingLines || !filteredLines || (filteredLines.length === 0 && (!lines || lines.length === 0))}
                                showSearch
                                filterOption={(input, option) =>
                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                }
                            >
                                {(filteredLines || lines).map(line => (
                                    <Option key={line.value} value={line.value}>
                                        {line.label}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </Col> */}

                {/* Model types section */}
                {/* <Col span={24}>
                        <div>
                            <Text>Select Type</Text>
                            <Select
                                mode="multiple"
                                placeholder={loadingModelTypes ? "Loading types..." : "Select model type"}
                                value={selectedFilters.modelTypes || []}
                                onChange={handleModelTypeChange}
                                style={{ width: '100%', marginTop: '8px' }}
                                loading={loadingModelTypes}
                                disabled={loadingModelTypes || !modelTypesData || modelTypesData.length === 0}
                                allowClear
                                maxTagCount={2}
                                maxTagPlaceholder={(omitted) => `+ ${omitted.length} types`}
                                showSearch
                                filterOption={(input, option) =>
                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                }
                            >
                                {modelTypesData && modelTypesData.map(modelType => (
                                    <Option key={modelType.value} value={modelType.value}>
                                        {modelType.label}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </Col> */}

                {/* Genders section */}
                {/* <Col span={24}>
                        <div>
                            <Text>Select Gender</Text>
                            <Select
                                mode="multiple"
                                placeholder={loadingGenders ? "Loading genders..." : "Select gender"}
                                value={selectedFilters.genders || []}
                                onChange={handleGenderChange}
                                style={{ width: '100%', marginTop: '8px' }}
                                loading={loadingGenders}
                                disabled={loadingGenders || !gendersData || gendersData.length === 0}
                                allowClear
                                maxTagCount={2}
                                maxTagPlaceholder={(omitted) => `+ ${omitted.length} genders`}
                                showSearch
                                filterOption={(input, option) =>
                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                }
                            >
                                {gendersData && gendersData.map(gender => (
                                    <Option key={gender.value} value={gender.value}>
                                        {gender.label}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </Col> */}

                {/* Size section */}
                {/* <Col span={24}>
                        <div>
                            <Text>Select Size</Text>
                            <Select
                                mode="multiple"
                                placeholder={loadingSizes ? "Loading sizes..." : "Select size"}
                                value={selectedFilters.sizes || []}
                                onChange={handleSizeChange}
                                style={{ width: '100%', marginTop: '8px' }}
                                loading={loadingSizes}
                                allowClear
                                maxTagCount={2}
                                maxTagPlaceholder={(omitted) => `+ ${omitted.length} sizes`}
                                disabled={loadingSizes || !sizesData || sizesData.length === 0}
                                showSearch
                                filterOption={(input, option) =>
                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                }
                            >
                                {sizesData && sizesData.map(size => (
                                    <Option key={size.value} value={size.value}>
                                        {size.label}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </Col> */}

                {/* Frame Color section - Solo per Admin */}
                {/* {userRole === 'Admin' && (
                        <Col span={24}>
                            <div>
                                <Text>Select Frame Color</Text>
                                <Select
                                    mode="multiple"
                                    placeholder={loadingFrameColors ? "Loading frame colors..." : "Select frame color"}
                                    value={selectedFilters.frameColors || []}
                                    onChange={handleFrameColorChange}
                                    style={{ width: '100%', marginTop: '8px' }}
                                    loading={loadingFrameColors}
                                    allowClear
                                    maxTagCount={2}
                                    maxTagPlaceholder={(omitted) => `+ ${omitted.length} colors`}
                                    disabled={loadingFrameColors || !frameColorsData || frameColorsData.length === 0}
                                    showSearch
                                    filterOption={(input, option) =>
                                        option?.children?.toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    {frameColorsData && frameColorsData.map(color => (
                                        <Option key={color.value} value={color.value}>
                                            {color.label}
                                        </Option>
                                    ))}
                                </Select>
                            </div>
                        </Col>
                    )} */}

                {/* Frame Shape section - Solo per Admin */}
                {/* {userRole === 'Admin' && (
                        <Col span={24}>
                            <div>
                                <Text>Select Frame Shape</Text>
                                <Select
                                    mode="multiple"
                                    placeholder={loadingFrameShapes ? "Loading frame shapes..." : "Select frame shape"}
                                    value={selectedFilters.frameShapes || []}
                                    onChange={handleFrameShapeChange}
                                    style={{ width: '100%', marginTop: '8px' }}
                                    loading={loadingFrameShapes}
                                    allowClear
                                    maxTagCount={2}
                                    maxTagPlaceholder={(omitted) => `+ ${omitted.length} shapes`}
                                    disabled={loadingFrameShapes || !frameShapesData || frameShapesData.length === 0}
                                    showSearch
                                    filterOption={(input, option) =>
                                        option?.children?.toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    {frameShapesData && frameShapesData.map(shape => (
                                        <Option key={shape.value} value={shape.value}>
                                            {shape.label}
                                        </Option>
                                    ))}
                                </Select>
                            </div>
                        </Col>
                    )} */}

                {/* Age section */}
                {/* <Col span={24}>
                        <div>
                            <Text>Select Age</Text>
                            <Select
                                mode="multiple"
                                placeholder="Select age range"
                                value={selectedFilters.age || []}
                                onChange={handleAgeChange}
                                style={{ width: '100%', marginTop: '8px' }}
                                allowClear
                                maxTagCount={2}
                                maxTagPlaceholder={(omitted) => `+ ${omitted.length} age ranges`}
                                showSearch
                                filterOption={(input, option) =>
                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                }
                            >
                                <Option key="kids" value="kids">Kids</Option>
                                <Option key="adult" value="adult">Adult</Option>
                            </Select>
                        </div>
                    </Col> */}
                {/* </Row> */}

                {/* Action buttons */}
                <Row gutter={[8, 0]} style={{ marginTop: 'clamp(1rem, 2vw, 1.5rem)' }}>
                    <Col span={12}>
                        <OutlineButton
                            onClick={handleClearFilters}
                            style={{ width: '100%' }}
                        >
                            Reset Filters
                        </OutlineButton>
                    </Col>
                    <Col span={12}>
                        <PrimaryButton
                            onClick={handleApplyFilters}
                            style={{ width: '100%' }}
                            disabled={!hasFiltersToApply()}
                        >
                            Apply Filters
                        </PrimaryButton>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default CatalogueFilterBar; 